import { TreeData } from 'components/GenericTree';
import { ItemId } from '../types';

export const COLLAPSE: 'COLLAPSE' = 'COLLAPSE';
export const DELETE: 'DELETE' = 'DELETE';
export const EDIT: 'EDIT' = 'EDIT';
export const EXPAND: 'EXPAND' = 'EXPAND';
export const FILTER: 'FILTER' = 'FILTER';
export const RENAME: 'RENAME' = 'RENAME';
export const RESET_FILTER: 'RESET_FILTER' = 'RESET_FILTER';
export const SET_LOADING: 'SET_LOADING' = 'SET_LOADING';
export const SET_TREE: 'SET_TREE' = 'SET_TREE';

export const collapse = (payload: ItemId) => ({ type: COLLAPSE, payload });
export const deleteNode = (payload: ItemId) => ({ type: DELETE, payload });
export const expand = (payload: ItemId) => ({ type: EXPAND, payload });
export const filter = (payload: string) => ({ type: FILTER, payload });
export const rename = (id: ItemId, value: string) => ({
  type: RENAME,
  payload: { id, value },
});
export const resetSearch = () => ({ type: RESET_FILTER });
export const setEdit = (id: ItemId, value: boolean) => ({
  type: EDIT,
  payload: { id, value },
});
export const setLoading = (payload: boolean) => ({
  type: SET_LOADING,
  payload,
});
export const setTree = (payload: TreeData) => ({ type: SET_TREE, payload });

export type CollapseAction = ReturnType<typeof collapse>;
export type DeleteNodeAction = ReturnType<typeof deleteNode>;
export type ExpandAction = ReturnType<typeof expand>;
export type FilterAction = ReturnType<typeof filter>;
export type RenameAction = ReturnType<typeof rename>;
export type ResetSearchAction = ReturnType<typeof resetSearch>;
export type SetEditAction = ReturnType<typeof setEdit>;
export type SetLoadingAction = ReturnType<typeof setLoading>;
export type SetTreeAction = ReturnType<typeof setTree>;

export type Actions =
  | CollapseAction
  | DeleteNodeAction
  | ExpandAction
  | FilterAction
  | RenameAction
  | ResetSearchAction
  | SetEditAction
  | SetLoadingAction
  | SetTreeAction;
